angular.module('shared').filter('carriageReturn2HtmlBr', function () {
    return function (inputValue) {
        if (!!inputValue) {
            var result = inputValue
                .replace(/\r\n/g, '<br/>')
                .replace(/\r/g, '<br/>')
                .replace(/\n/g, '<br/>')
                .replace(/&#13;&#10;/g, '<br/>') // &#13;&#10; = \n\r
                .replace(/&#13;/g, '<br/>') // &#13; = \n
                .replace(/&#10;/g, '<br/>'); // &#10; = \r
            
            // for debug
            // console.log('carriageReturn2HtmlBr result = ', result);
            return result;
        }
        return inputValue;
    };
});

// get from https://github.com/angular/angular.js/blob/67688d5ca00f6de4c7fe6084e2fa762a00d25610/src/ngSanitize/sanitize.js#L450
angular.module('shared').filter('safeHtml', function () {
    return function (inputValue) {
        if (!inputValue) {
            return '';
        }
        let SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
            // Match everything outside of normal chars and " (quote character)
            NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g;


        var result = inputValue.
            replace(/&/g, '&amp;').
            replace(SURROGATE_PAIR_REGEXP, function (inputValue) {
                var hi = inputValue.charCodeAt(0);
                var low = inputValue.charCodeAt(1);
                return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
            }).
            replace(NON_ALPHANUMERIC_REGEXP, function (inputValue) {
                return '&#' + inputValue.charCodeAt(0) + ';';
            }).
            replace(/</g, '&lt;').
            replace(/>/g, '&gt;');

        // for debug
        // console.log('safeHtml result = ', result);
        return result;
    };
});